/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {Remuneration, ProductTypeEnum} from "./remuneration";
import { ProviderDTO, ProviderContactDTO } from "./providerDTO";
import { ScriptImports } from "./scriptImports";
import { ScriptImportsGroupProvider } from "./scriptImportsGroupProvider";

  export class Provider implements ProviderDTO {
    address1?: string;
    address2?: string;
    city?: string;
    zipcode?: string;
    country?: string;
    tva?: string;
    language?: 'fr' | 'en';
    siren?: string;
    products?: ProductTypeEnum[];
    remunerations?: Remuneration[];
    contact?: ProviderContactDTO;
    code: string;
    description?: string;
    id?: string;
    name: string;
    script?: ScriptImports;
    scriptsForGroupProvider?: ScriptImportsGroupProvider[];
  }


